import { yupResolver } from "@hookform/resolvers/yup";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { formValidate } from "helpers/form_helper";
import PropTypes from "prop-types";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { Button, Col, Form, FormGroup, Label, Row } from "reactstrap";
import * as yup from "yup";
import "./ChangeOrderStatusForm.scss";

export const checkIsAnyNotAllowedGroupToTransfer = (orderList, selectedIds) => {
  let result = false;
  if (
    orderList?.items &&
    orderList?.items.length > 0 &&
    selectedIds &&
    selectedIds.length > 0
  ) {
    selectedIds.forEach(id => {
      const findItem = orderList?.items.find(
        order => order.id === id && !order.allowed_group_to_transfer
      );

      if (findItem) {
        result = true;
      }
    });
  }

  return result;
};

const ChangeOrderStatusForm = props => {
  const { t } = useTranslation(["order"]);

  //init values
  const initDefaultValues = {
    status_id: undefined,
    note: "",
  };

  const schema = yup.object().shape({
    status_id: yup
      .object()
      .required(t("form.validate.select", { title: t("form.status_id") })),
    note: yup
      .string()
      .required(t("form.validate.required", { title: t("form.reason") })),
  });

  const { orderStatusList } = props;

  const orderStatusMenu = [];
  orderStatusList?.forEach(item => {
    if (
      item?.value === "4" ||
      item?.value === "5" ||
      item?.value === "6" ||
      item?.value === "3"
    )
      orderStatusMenu.push(item);

    if (item?.value === "8") {
      orderStatusMenu.push({
        ...item,
        label: props.isAnyNotAllowedGroupToTransfer
          ? `${item.label} (${
              props.placeHolderNotAllowedGroupToTransfer || ""
            })`
          : item.label,
        isDisabled: props.isAnyNotAllowedGroupToTransfer || false,
      });
    }
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: initDefaultValues,
  });

  const onSubmit = () => {
    const data = getValues();
    const orderStatus = {
      status: data?.status_id?.value,
      note: data?.note,
    };
    props?.handleCancel?.();
    props?.onSubmit(orderStatus);
  };
  return (
    <Form className="p-4 OrderStatusForm">
      <Row xs={1}>
        <Col>
          <FormGroup className="gy-2">
            <Label htmlFor="status_id">
              {t("form.status_id")} <span className="text-danger">*</span>
            </Label>

            <Controller
              control={control}
              name="status_id"
              render={({ field }) => (
                <Select
                  {...field}
                  placeholder={t("placeholder.select", {
                    title: t("form.status_id"),
                  })}
                  //   value={runner}
                  options={orderStatusMenu}
                  isSearchable
                  className="basic-single w-100"
                  classNamePrefix="select"
                  //   onChange={handleChangeRunner}
                />
              )}
            />
            {errors.status_id && (
              <MessageFormValidate error={errors.status_id.message} />
            )}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label htmlFor="note">
              {t("form.reason")} <span className="text-danger">*</span>
            </Label>
            <textarea
              type="textarea"
              className={`form-control ${formValidate(
                errors,
                touchedFields,
                "note"
              )}`}
              name="note"
              placeholder={t("placeholder.note")}
              rows={5}
              {...register("note")}
            />
            {errors.note && <MessageFormValidate error={errors.note.message} />}
          </FormGroup>
        </Col>
        <Col>
          <Row xs={2}>
            <Col>
              <Button
                color="danger"
                outline
                className="border-0"
                size="xs"
                onClick={props?.handleCancel}
              >
                {t("button.cancel")}
              </Button>
            </Col>
            <Col className="text-end">
              <Button
                size="xs"
                color="primary"
                style={{ backgroundColor: "#3C64B1" }}
                onClick={() => handleSubmit(onSubmit)()}
              >
                {t("button.confirm")}
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

ChangeOrderStatusForm.propTypes = {
  orderStatusList: PropTypes.array,
  handleCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  isAnyNotAllowedGroupToTransfer: PropTypes.bool,
  placeHolderNotAllowedGroupToTransfer: PropTypes.string,
};
export default ChangeOrderStatusForm;
